import React, {PureComponent} from "react"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import {Query} from "@irati/utils/apollo"


import {Poll} from "@irati/types"
import {gql} from "@irati/utils/gql"
import PollFragment from "../fragments/Poll"

export interface FeedPollVariables {
  id: string
}

export interface FeedPollData {
  data: {
    poll: Poll
  }
}

interface Props {
  variables: FeedPollVariables
}

const query = gql`
  query Poll($id: String) {
    poll(id: $id) {
      ...Poll
    }
  }

  ${PollFragment}
`

// @todo used by web
// Once web is refactored to use QueryComponent delete this
export const feedPollQuery = {
  query
}

class TypedQuery extends Query<FeedPollData, FeedPollVariables> {}

export default class FeedPollQuery extends PureComponent<Props> {
  render() {
    return <QueryComponent {...this.props} QueryComponent={TypedQuery} query={query} />
  }
}
